import { OfferStatusHistoryModel } from './../offer/offerStatusHistoryModel';
import { FileSyncModel } from './fileSyncModel';
import { UserModel } from './../user/userModel';
import { LocationSyncModel } from './locationSyncModel';
import { ClientSyncModel } from './clientSyncModel';
import { OfferInstallationSyncModel } from './offerInstallationSyncDTO';

export class OfferSyncModel {
    public id: number;
    public localId: number;
    public date: string;
    public number: string;
    public notes: string;
    public price: number;
    public discount: number;
    public fixedDiscount: number;
    public traderId: number;
    public clientId: number;
    public clientLocalId: number;
    public statusId: number;
    public clientEmail: string;
    public clientName: string;
    public clientPhone: string;
    public isActive: boolean;
    public locationAddress: string;
    public locationDistrict: string;
    public locationId: number;
    public locationLocalId: number;
    public locationMunicipality: string;
    public locationTown: string;
    public locationLatitude: string;
    public locationLongitude: string;
    public client: ClientSyncModel;
    public location: LocationSyncModel;
    public trader: UserModel;
    public isolationTypeId: number
    public roomHeight: number;
    public planner: string;
    public activeStep: number;
    public completedSteps: string;
    public isWithHeathInstall: boolean;
    public isWithWorkAndMaterials: boolean;
    public disclaimer: string;
    public gasInstallation: OfferInstallationSyncModel;
    public heathInstallation: OfferInstallationSyncModel | null;
    public files: Array<FileSyncModel>;
    public statusHistory: Array<OfferStatusHistoryModel>;
    public updatedOn: string;
    public priceChanged: boolean;
    public remoteUpdatedOn: string;
    public adminNotes: string;
    public equipmentOnly: boolean;
}